import * as React from "react";
import { cn } from "@/lib/utils";

type BtnSimpleIconProps = React.ComponentPropsWithoutRef<"button"> & {
  icon: React.ReactNode;
  tone?: "default" | "destructive";
};

export const BtnSimpleIcon = React.forwardRef<
  HTMLButtonElement,
  BtnSimpleIconProps
>(function BtnSimpleIcon(
  { icon, tone = "default", type = "button", className, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        "p-1.5 transition-colors",
        tone === "destructive"
          ? "text-muted-foreground hover:text-destructive"
          : "text-muted-foreground hover:text-foreground",
        className
      )}
      {...rest}
    >
      {icon}
    </button>
  );
});

BtnSimpleIcon.displayName = "BtnSimpleIcon";

